import { isEqual, includes, hasIn } from 'lodash';
import { flattenAnswers } from './flattenAnswers';

export function checkIfNotEqualTo(profile, condition) {
  const clonedProfile = flattenAnswers(profile);

  const { ifId, ifValue } = condition;

  const profileValue = clonedProfile[ifId];

  // Check in store if the condition not equals
  if (!hasIn(clonedProfile, ifId)) {
    // In case the ifId is not in profile
    return true;
  }
  if (Array.isArray(profileValue) && !Array.isArray(ifValue)) {
    // In case the attribute is array of strings
    return !includes(profileValue, ifValue);
  }
  if (!Array.isArray(profileValue) && Array.isArray(ifValue) && ifValue.length === 1) {
    return !includes([profileValue], ifValue[0]);
  }
  const checkIf = isEqual(clonedProfile[ifId], ifValue);

  return !checkIf;
}
